import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { onOpenModal } from '../../store/actions/modal';
import { logout } from '../../store/actions/user';
import { LINK_LIST } from '../Modal/types';

import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import _Button from '../Button';

const Div = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
`;

const Button = styled(_Button)`
  margin: 10px 10px;
`;

function Navigation({ openModal, logout }) {
  return (
    <Div>
      <Button onClick={openModal} outlined color="white">
        List Links
      </Button>
      <Button onClick={logout} outlined color="white">
        <ExitToAppIcon />
      </Button>
    </Div>
  );
}

Navigation.propTypes = {
  openModal: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
};

const mapDispatchToProps = (d) => ({
  openModal: () => d(onOpenModal({ variant: LINK_LIST })),
  logout: () => d(logout()),
});

const connected = connect(null, mapDispatchToProps)(Navigation);

export default connected;
